import React, { useEffect, useRef, useState, useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import { Star } from "lucide-react";

const Testimonials = ({ messages: propMessages }) => {
  const defaults = [];

  const { theme } = useContext(ThemeContext);
  // On ne tronque plus, on prend ce qui est fourni (déjà 5 max, aléatoire)
  const messages = propMessages && propMessages.length ? propMessages : defaults;

  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);
  const containerRef = useRef(null);

  // Carrousel automatique et manuel (déjà déclaré plus haut)

  // Les fonctions startAutoplay et stopAutoplay sont déjà déclarées plus haut, on retire ce doublon

  useEffect(() => {
    if (!messages.length) return undefined;
    startAutoplay();
    return () => stopAutoplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages.length]);

  const startAutoplay = () => {
    stopAutoplay();
    intervalRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % messages.length);
    }, 4000);
  };

  const stopAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  return (
    <section className="py-14" aria-label="Dernières notes clients">
      <div
        ref={containerRef}
        onMouseEnter={stopAutoplay}
        onMouseLeave={startAutoplay}
        className="relative w-full max-w-7xl mx-auto px-4"
      >
        <div
          className={`w-full rounded-3xl border p-6 md:p-10 flex flex-col lg:flex-row items-start gap-8 shadow-lg transition relative ${
            theme === "dark" ? "bg-white/[0.03] border-white/10" : "bg-white/95 border-rose-100/80"
          }`}
        >
          <div className="flex items-center gap-4">
            <div
              className={`h-16 w-16 rounded-2xl flex items-center justify-center text-xl font-bold ${
                theme === "dark" ? "bg-rose-500/10 text-white" : "bg-rose-50 text-gray-900"
              }`}
            >
              {(messages[index]?.author || "K").charAt(0)}
            </div>
            <div>
              <div className={`text-lg font-semibold ${theme === "dark" ? "text-white" : "text-gray-900"}`}>
                {messages[index]?.author || "Client"}
              </div>
              <div className={`${theme === "dark" ? "text-white/50" : "text-gray-500"}`}>
                @{messages[index]?.handle || "client"}
              </div>
            </div>
          </div>

          <div className="flex-1">
            {messages.length ? (
              <>
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, starIndex) => {
                    const filled = (messages[index]?.rating || 0) > starIndex;
                    return (
                      <Star
                        key={starIndex}
                        className={`w-5 h-5 ${
                          filled
                            ? theme === "dark"
                              ? "text-rose-400 fill-rose-400"
                              : "text-rose-500 fill-rose-500"
                            : theme === "dark"
                            ? "text-white/30"
                            : "text-gray-300"
                        }`}
                      />
                    );
                  })}
                </div>
                <p className={`mt-4 text-xl md:text-2xl leading-relaxed ${theme === "dark" ? "text-white" : "text-gray-900"}`}>
                  {messages[index]?.text}
                </p>
                <div className={`mt-3 text-sm ${theme === "dark" ? "text-white/60" : "text-gray-600"}`}>
                  {messages[index]?.productName}
                </div>
                <div className={`mt-4 text-xs uppercase tracking-[0.2em] ${theme === "dark" ? "text-white/40" : "text-gray-500"}`}>
                  Dernières notes clients
                </div>
              </>
            ) : (
              <p className={`${theme === "dark" ? "text-white/60" : "text-gray-600"}`}>
                Les notes clients apparaitront ici des qu'elles seront publiées.
              </p>
            )}
          </div>

          <div className="w-full lg:w-auto flex gap-2">
            {messages.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                aria-label={`Aller au témoignage ${i + 1}`}
                className={`h-2.5 w-2.5 rounded-full transition-colors ${
                  i === index
                    ? theme === "dark"
                      ? "bg-rose-400"
                      : "bg-rose-500"
                    : theme === "dark"
                    ? "bg-white/30"
                    : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
